module.exports = __webpack_public_path__ + "static/media/2005.2c60bcd6.svg";